/*
* 车辆信息管理组件
* zxw
* 创建时间：
* 修改时间：2026-07-09
*/

import React, { useState, useEffect, useCallback, useMemo } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    message,
    Table,
    Input,
    Select,
    Button,
    Space,
    Statistic,
    Tag,
    theme,
} from 'antd';
import {
    PlusOutlined,
    ExportOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    DateFormat,
    isGTscreenWidth,
    ShowIPModal,
    GetDropdownActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './CarEntity';
import CarMileageEntity from './CarMileageEntity';
import CarInfo from './CarInfo.js';

const MODULENAME = CNF.navItems[1].submenu[0].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[1].submenu[0].ptn;
const MODULENAME_URL = CNF.navItems[1].submenu[0].url;

const Lists = (props) => {
    const { btnLists, dataLists, currentIndex, pageCount, changeIndex, setOpen, refresh, preGroup } = props;

    const {
        token: {
            colorPrimary,
            colorPrimaryBg,
            fontSize,
            pageSize,
        },
    } = theme.useToken();

    const [record, setRecord] = useState(null);
    const [openMileage, setOpenMileage] = useState(false);
    const [openCarInfo, setOpenCarInfo] = useState(false);

    const update = useCallback((record) => {
        setOpen(true, record);
    }, [setOpen]);

    const setOpenMileageModel = useCallback((open, record) => {
        setRecord(record);
        setOpenMileage(open);
    }, []);

    const setOpenCarInfoModel = useCallback((open, record) => {
        setRecord(record);
        setOpenCarInfo(open);
    }, []);

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
    */
    const operation = useCallback((action, record) => {
        const uri = MODULENAME_URL.slice(1) + '/' + record.key;
        switch (action) {
            case '里程':
                setOpenMileageModel(true, record);
                break;
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.rolename, action, MODULENAME, refresh, uri);
                break
            default:
                break;
        }
    }, [refresh, update, setOpenMileageModel]);

    const hasOpPerm = (
        btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
        btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
    );

    const columns = useMemo(() => [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        {
            title: '车牌号码', key: 'license_number', fixed: 'left', width: 120,
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: 0, margin: 0, height: 22 }}
                onClick={() => { setOpenCarInfoModel(true, record) }}
            >{record.license_number}</Button>
        },
        { title: '车辆名称', dataIndex: 'name', key: 'name', },
        { title: '车辆型号', dataIndex: 'model', key: 'model', },
        { title: '驾驶人员', dataIndex: 'driver_displayname', key: 'driver_displayname', },
        { title: '用途', dataIndex: 'uses', key: 'uses', ellipsis: true, hidden: isGTscreenWidth ? false : true, },
        { title: '购买时间', dataIndex: 'purchase_time', key: 'purchase_time', },
        {
            title: '当前里程(km)', key: 'current_mileage',
            render: (record) => <Tag color={colorPrimaryBg} style={{ width: '50%' }}><Statistic styles={{ content: { fontSize: fontSize - 2, color: colorPrimary } }} value={record.current_mileage} /></Tag>
        },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', key: 'status', fixed: 'right', dataIndex: 'status', width: CNF.tableStatusColumnWidth, },
        {
            title: '', key: 'operation', fixed: 'right', width: CNF.tableOperationColumnWidth, hidden: !hasOpPerm,
            render: (record) => GetDropdownActionName(btnLists, MODULENAME_PTN, record, operation)
        }
    ], [btnLists, hasOpPerm, operation, fontSize, colorPrimary, colorPrimaryBg, setOpenCarInfoModel]);

    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={dataLists}
                pagination={{
                    showSizeChanger: false,
                    showQuickJumper: false,
                    showTotal: () => `共${pageCount > 10000 ? (pageCount / 10000).toFixed(CNF.DPL) + '万' : pageCount}条`,
                    pageSize: pageSize,
                    current: currentIndex,
                    total: pageCount,
                    onShowSizeChange: (current, pageSize) => props?.changePageSize(pageSize, current),
                    onChange: (current) => changeIndex(current),
                }}
            />
            {
                record && <CarMileageEntity
                    refresh={refresh}
                    record={record}
                    open={openMileage}
                    setOpen={setOpenMileageModel}
                />
            }
            {
                record && <CarInfo
                    preGroup={preGroup}
                    record={record}
                    open={openCarInfo}
                    setOpen={setOpenCarInfoModel}
                />
            }
        </>
    );
}

const Car = (props) => {
    const { btnLists, preGroup } = props;

    const { token: { pageSize, }, } = theme.useToken();

    const [loading, setLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [triggerRefresh, setTriggerRefresh] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);
    const [status, setStatus] = useState(CNF.status[0].value);
    const refresh = useCallback(() => {
        setTriggerRefresh((prev) => prev + 1);
    }, []);

    const [licenseNumber, setLicenseNumber] = useState('');
    const [driverDisplayname, setDriverDisplayname] = useState('');

    const setOpenModal = useCallback((value, record) => {
        setOpen(value);
        setRecord(record || null);
    }, []);

    const create = useCallback(() => {
        setOpenModal(true, null);
    }, [setOpenModal]);

    const changeIndex = useCallback((index) => {
        setCurrentIndex(index);
    }, []);

    const handleStatusChange = useCallback((value) => {
        setStatus(value || '');
        setCurrentIndex(1);
    }, []);

    const handleLicenseNumberChange = useCallback((e) => {
        setLicenseNumber(e.target.value);
        setCurrentIndex(1);
    }, []);

    const handleDriverDisplaynameChange = useCallback((e) => {
        setDriverDisplayname(e.target.value);
        setCurrentIndex(1);
    }, []);

    useEffect(() => {
        setLoading(true);

        let params = {
            page_size: pageSize,
            current_index: currentIndex,
            status,
            license_number: licenseNumber,
            driver_displayname: driverDisplayname,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                setDataLists(data.dat || []);
                setPageCount(data.cnt || 0);
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        }).always(() => setLoading(false))
    }, [messageApi, pageSize, currentIndex, triggerRefresh, status, licenseNumber, driverDisplayname]);


    /***
    * 导出为 Excel
    */
    const exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '车辆信息明细-' + DateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '车辆信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '车牌号码',
                    '车辆名称',
                    '车辆型号',
                    '驾驶人员',
                    '用途',
                    '购买时间',
                    '当前里程（km）',
                    '状态',
                    '备注'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }

    /***
     * 获取导出数据
     */
    const exportGetData = () => {
        let params = {
            page_size: CNF.maxPageSize,
            current_index: 1,
            status,
            license_number: licenseNumber,
            driver_displayname: driverDisplayname,
        };

        // 注意：如果 0 也是有效值，需要额外处理，但此处页码和数量通常不为0或空
        params = Object.fromEntries(
            Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
        );

        $.ajax({
            url: `${CNF.api}${MODULENAME_URL.slice(1)}${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET',
        }).done((data) => {
            if (data.res === 0) {
                if (data.dat.length > 0) {
                    //  删除非必须字段
                    var d = [];
                    for (let i = 0; i < data.dat.length; i++) {
                        var item = data.dat[i]
                        delete item['key'];
                        delete item['driver_username']
                        delete item['create_username']
                        delete item['create_displayname']
                        delete item['create_time']
                        delete item['update_time']
                        d.push(item);
                    }
                    exportAsExcel(d);
                } else {
                    exportAsExcel([]);
                }
            } else {
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail((err) => {
            messageApi.error(err.responseJSON?.detail || '请求失败', CNF.messageDuration);
        })
    }

    // 按钮权限判断
    const hasCreate = btnLists.includes(MODULENAME_PTN + '_create');
    const hasExport = btnLists.includes(MODULENAME_PTN + '_export');


    return (
        <>
            {contextHolder}
            <Space style={{ padding: CNF.searchMarginLeft * 4 }}>
                <Input
                    placeholder='车牌号码'
                    value={licenseNumber}
                    onChange={handleLicenseNumberChange}
                />

                <Input
                    placeholder='驾驶人员'
                    value={driverDisplayname}
                    onChange={handleDriverDisplaynameChange}
                />
                <Select
                    allowClear
                    placeholder='状态'
                    style={{ width: '100%' }}
                    onChange={handleStatusChange}
                    value={status ? status : undefined}
                    options={CNF.status.map((item, index) => ({
                        key: index,
                        value: item.value,
                        label: item.label
                    }))}
                />
                {hasCreate && (
                    <Button
                        title={CNF.actionName.CREATE + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<PlusOutlined />}
                        onClick={() => {
                            create();
                        }}>
                        {CNF.actionName.CREATE}
                    </Button>
                )}
                {hasExport && (
                    <Button
                        title={CNF.actionName.EXPORT + MODULENAME}
                        color='primary'
                        variant='solid'
                        icon={<ExportOutlined />}
                        onClick={() => {
                            exportGetData();
                        }}>
                        {CNF.actionName.EXPORT}
                    </Button>
                )}
            </Space>
            <Lists
                btnLists={btnLists}
                preGroup={preGroup}
                dataLists={dataLists}
                currentIndex={currentIndex}
                pageCount={pageCount}
                changeIndex={changeIndex}
                setOpen={setOpenModal}
                refresh={refresh}
                loading={loading}
            />
            <Entity
                preGroup={preGroup}
                btnLists={btnLists}
                open={open}
                record={record}
                setOpen={setOpenModal}
                refresh={refresh}
            />
        </>
    );
}

export default Car